import { useEffect, useState } from 'react';
import EsriHeader from './header/EsriHeader';
import ViewLogin from './ViewLogin';

const THEME_STORAGE_KEY = 'portal-comunidad-theme';

const PrincipalView = (vm) => {
    const [theme, setTheme] = useState(() => {
        const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
        return savedTheme === 'dark' ? 'dark' : 'light';
    });

    useEffect(() => {
        window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    }, [theme]);

    return (
        <div className={`app-theme-shell h-full flex flex-col ${theme === 'dark' ? 'app-dark' : ''}`}>
            <EsriHeader
                currentUser={vm.currentUser}
                activeTab={vm.activeTab}
                permission={vm.permission}
                onTabChange={vm.setActiveTab}
                onLogout={vm.closeSession}
                losesAccess={vm.losesAccess}
                theme={theme}
                setTheme={setTheme}
            />
            {vm.activeTab == 'never' ? (
                <div className="flex-1 flex items-center justify-center px-4">
                    <div className="text-center">
                        <p className="text-2xl md:text-4xl font-bold text-gray-700">
                            No se puede visualizar ningún módulo
                        </p>
                        <p className="mt-3 text-sm md:text-base text-gray-500">
                            Contacte al administrador para obtener accesos
                        </p>
                    </div>
                </div>
            ) : (
                <ViewLogin 
                    activeTab={vm.activeTab}
                    permission={vm.permission}
                    currentUser={vm.currentUser}
                    theme={theme}
                    init={vm.init}
                    initView={vm.initView}
                    losesAccess={vm.losesAccess}
                    setActiveTab={vm.setActiveTab}
                    setCurrentUser={vm.setCurrentUser}
                    expireSesion={vm.expireSesion}
                    updateMessage={vm.updateMessage}
                    onLogout={vm.closeSession}
                />
            )}
        </div>
    );
};

export default PrincipalView;
